export enum UserDomain {
  CONWAY = 'CONWAY',
  CONWAY_AD = 'CONWAY-AD',
  CTS = 'CTS',
  CTS_AD = 'CTS-AD',
  CFI = 'CFI',
  CFI_AD = 'CFI-AD',
}
